import { createAppStore } from '@store/createAppStore';

import { CarrierLaneSearchState } from './types';

const [laneSearchStore, setLaneSearchStore] =
  createAppStore<CarrierLaneSearchState>(
    {
      isLoading: false,
      isError: false,
      errorMessage: '',
      laneSearch: [],
      overlay: false,
    },
    'laneSearchStore',
  );

export { laneSearchStore, setLaneSearchStore };
